export const MOVING_PRICING = {
  minimumVolume: 20,
  standardRate: 400,
  reducedThreshold: 40,
  reducedRate: 380,
  ferry: 500,
  storageMonthly: 350,
  currency: "EUR",
} as const;

/** Entire-volume tiers; ferry is mandatory, storage is optional and individually arranged. */
export function movingEstimate(volume: number, storageMonths = 0) {
  if (!Number.isFinite(volume) || volume < MOVING_PRICING.minimumVolume || !Number.isInteger(storageMonths) || storageMonths < 0) return null;
  const rate = volume >= MOVING_PRICING.reducedThreshold ? MOVING_PRICING.reducedRate : MOVING_PRICING.standardRate;
  const transport = Math.round(volume * rate * 100) / 100;
  const storage = storageMonths * MOVING_PRICING.storageMonthly;
  const total = Math.round((transport + MOVING_PRICING.ferry + storage) * 100) / 100;
  if (!Number.isSafeInteger(Math.round(total * 100))) return null;
  return { volume, rate, transport, ferry: MOVING_PRICING.ferry, storageMonths, storage, total };
}

export const MOVING_META = {
  title: "Umzug nach Nordzypern – Preise & Service | CYPRUS PRIVÉ",
  description: "Umzugsservice nach Nordzypern: ab 20 m³ 400 €/m³, ab 40 m³ 380 €/m³. Zuzüglich 500 € Fährkosten. Optionale Einlagerung 350 €/Monat. Zoll, Einpacken und Verpacken inklusive.",
};
